import {useContext} from "react";
import SiteContext from "../context";

function useSite() {
  return useContext(SiteContext);
}

export default useSite;
